import { Icon } from "@/components/ui/icon";
import { Button } from "@/components/ui/button";
import { ATSResumeDownload } from "./ATSResumeDownload";

interface HeroSectionProps {
  profile?: {
    full_name: string;
    location?: string;
    email?: string;
    linkedin_url?: string;
    website_url?: string;
    github_url?: string;
    resume_pdf_url?: string;
    profile_photo_url?: string;
    summary?: string;
  } | null;
}

export const HeroSection = ({ profile }: HeroSectionProps) => {
  if (!profile) return null;

  return (
    <section id="hero" className="bg-card">
      <div className="max-w-6xl mx-auto container-padding section-padding">
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-10 md:gap-12">
          <div className="flex-1 max-w-2xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-5 leading-[1.1] animate-fade-in">
              {profile.full_name}
            </h1>
            
            {profile.summary && (
              <p className="text-lg text-muted-foreground mb-8 leading-relaxed animate-fade-in animation-delay-100">
                {profile.summary}
              </p>
            )}

            <div className="flex flex-wrap gap-3 animate-fade-in animation-delay-200">
              <ATSResumeDownload />
              
              {profile.email && (
                <Button
                  asChild
                  variant="outline"
                  className="rounded-full border-primary/30 hover:bg-primary/10 hover:border-primary/50 text-primary"
                >
                  <a href={`mailto:${profile.email}`}>
                    <Icon name="mail" size={18} className="mr-2" />
                    Contact Me
                  </a>
                </Button>
              )}
            </div>
          </div>

          <div className="flex-shrink-0 animate-scale-in">
            <div className="size-52 md:size-60 lg:size-64 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 shadow-xl overflow-hidden ring-1 ring-border/50">
              {profile.profile_photo_url ? (
                <img 
                  src={profile.profile_photo_url} 
                  alt={profile.full_name}
                  className="w-full h-full object-cover"
                  loading="eager"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-primary/60">
                  <Icon name="person" size={100} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
